import React from 'react';
import { resolveBaseUrl } from './../../Utils/urlHelper';

export const DownloadExampleFiles = () => (
  <p className="example-files-link">
    <a href={`${resolveBaseUrl()}chromosome/get-example-files`}>
      Download sample files
    </a>{' '}
    to try the app.
  </p>
);
